import { createSlice } from "@reduxjs/toolkit";

const chatSlice = createSlice({
    name: "chatSlice",
    initialState: {
        currentChat: null,
        totalUnreadMessage: 0,
        unReadMessage: [],
        unSeenMessage: [],
        allChatMessage: [],
        chatList: [],
        openChat: false
    },
    reducers: {
        setCurrentChat: (state, action) => {
            state.currentChat = action.payload;
        },
        setChatList: (state, action) => {
            state.chatList = action.payload;
        },
        updateChatListWithUnreadData: (state, action) => {
            state.totalUnreadMessage = state.totalUnreadMessage + 1;
            let oldMsg = state.chatList.map((data) => {
                if (data.chatId === action.payload.chatId) {
                    return { ...data, 'unReadMsg': data.unReadMsg + 1, 'lastMessage': action.payload.content }
                } else {
                    return data;
                }
            });
            state.chatList = oldMsg;
        },
        setOpenChat: (state, action) => {
            state.openChat = action.payload;
        },
        setTotalUnReadMessage: (state, action) => {
            state.totalUnreadMessage = action.payload;
        },
        setAllChatMessage: (state, action) => {
            state.allChatMessage = [...action.payload].reverse();
        },
        updateChatMessage: (state, action) => {
            if (action.payload.messageStatus === 'SEEN') {
                state.totalUnreadMessage = totalUnreadMessage - 1;
            }
            const updatedChatMessage = state.allChatMessage.map((msg) => msg.chatMessageId === action.payload.chatMessageId ? { ...msg, messageStatus: action.payload.messageStatus } : msg);
            state.allChatMessage = updatedChatMessage;
        },
        updateGroupChatMessage: (state, action) => {
            console.log("Before update", JSON.parse(JSON.stringify(state.allChatMessage))); // ✅ Safe log

            state.allChatMessage = state.allChatMessage.map((msg) => {
                if (msg.chatMessageId === action.payload.chatMessageId) {
                    // Update the status for the correct receiver
                    const updatedReceiverStatus = msg.receiverIdAndStatus.map((data) =>
                        data.receiverId === action.payload.receiverId
                            ? { ...data, messageStatus: action.payload.messageStatus }
                            : data
                    );

                    // Update the message object immutably
                    return {
                        ...msg,
                        receiverIdAndStatus: updatedReceiverStatus,
                    };
                }
                return msg; // Keep other messages unchanged
            });

            console.log("After update", JSON.parse(JSON.stringify(state.allChatMessage))); // ✅ Safe log
        },
        setAllChatMessageKeepOldMessage: (state, action) => {
            const map = new Map();

            // 1️⃣ Keep existing messages
            state.allChatMessage.forEach(msg => {
                map.set(msg.chatMessageId, msg);
            });

            // 2️⃣ Reverse NEW messages (without mutating original payload)
            const reversedNewMessages = [...action.payload].reverse();

            // 3️⃣ Add / overwrite with reversed new ones
            reversedNewMessages.forEach(msg => {
                map.set(msg.chatMessageId, msg);
            });

            // 4️⃣ Convert back to array
            state.allChatMessage = Array.from(map.values());
        },
        setChatMessageOneByOne: (state, action) => {
            state.allChatMessage = [action.payload, ...state.allChatMessage];
        },
        setUnReadMessageList: (state, action) => {
            state.unReadMessage = action.payload;
        },
        setUnSeenMessages: (state, action) => {
            const exists = state.unSeenMessage.some(
                (msg) => msg.chatMessageId === action.payload.chatMessageId
            );

            if (!exists) {
                state.unSeenMessage.push(action.payload);
            }
        },
        setUnReadMessageOneByOne: (state, action) => {
            state.totalUnreadMessage = state.totalUnreadMessage + 1;
            let oldData = state.unReadMessage.find(item => item.id === action.payload.id)
            if (oldData) {
                oldData.count += 1;
                oldData.content = action.payload.content;
            } else {
                state.unReadMessage.push({ ...action.payload, count: 1 });
            }
        },
    }
})
export const chatActions = chatSlice.actions;
export default chatSlice.reducer;